import React, { useState } from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import WildcardTextInput, {
  WildcardInputQuestionTypes,
} from 'pages/Forms/FormsContent/FormsDrafting/WildcardInputs/WildcardTextInput';
import WildCardButton from 'shared/components/WildCardButton';

interface ISurveryComposeQuestion {
  titleComponent: JSX.Element;
  placeholder: string;
  type: WildcardInputQuestionTypes;
  handleChange: (newValue: string) => void;
  validate?: (text: string) => boolean;
  errorMessage?: string;
  inputRef?: React.MutableRefObject<HTMLInputElement | null> | undefined;
  textAreaRef?: React.MutableRefObject<HTMLTextAreaElement | null> | undefined;
  value?: string;
  children?: JSX.Element;
}

const SurveyComposeQuestion = ({
  titleComponent,
  placeholder,
  type,
  handleChange,
  validate,
  errorMessage,
  inputRef,
  textAreaRef,
  value,
  children,
}: ISurveryComposeQuestion): JSX.Element => {
  const [showPreview, setShowPreview] = useState<boolean | undefined>(true);

  const handleAddWildCard = (value: string): void => {
    setShowPreview(false);
    handleChange(value);
  };

  return (
    <Flex
      className={`compose__question-${type}`}
      direction="column"
      bg="background.subtle"
      w="100%"
      mt={6}
      p={6}
      fontSize="md"
      borderRadius={8}
    >
      {titleComponent}
      <Flex className="compose__question-input" direction="column" mt={4}>
        <WildcardTextInput
          text={value || ''}
          placeholder={placeholder}
          type={type}
          showPreview={showPreview}
          inputRef={inputRef}
          textAreaRef={textAreaRef}
          allowFillInTheBlanks={false}
          handleChange={handleChange}
          setShowPreview={setShowPreview}
          validate={validate}
          errorMessage={errorMessage}
        />
        <WildCardButton
          textAreaRef={inputRef || textAreaRef}
          stateHandler={handleAddWildCard}
          setShowPreview={setShowPreview}
          time
          petName
          clinicName
        />
        {children}
      </Flex>
    </Flex>
  );
};

export default SurveyComposeQuestion;
